import EmergencyMapContainer from './EmergencyMapContainer';

export default EmergencyMapContainer;
